import apiClient from './api';
import { type AssignServiceBookingOrderRequest, type ServiceBookingOrder } from './serviceBookingOrderService';

export interface ServiceBookingOrderPoolServiceTime {
  serviceDate: string;
  serviceTimeDesc: string;
  status: string;
  assignedStaffId: string;
  assignedStaffName: string;
  assignedStaffPhone: string;
}

export interface ServiceBookingOrderPoolItem {
  id: string;
  orderId: string;
  orderItemId: string;
  orderNo: string;
  productName: string;
  categoryName: string;
  petQuantity: number;
  contactName: string;
  contactPhone: string;
  addressText: string;
  totalAmount: number;
  payStatus: string;
  status: string;
  statusText: string;
  serviceDate: string;
  serviceDateStart: string;
  serviceDateEnd: string;
  serviceTimeDesc: string;
  serviceTimes?: ServiceBookingOrderPoolServiceTime[];
  estimatedIncome: number;
  assignedStaffId: string;
  assignedStaffName: string;
  assignedStaffPhone: string;
  isPai: number;
  dispatchRemark: string;
  source: string;
  retryCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface ServiceBookingOrderPoolListParams {
  page?: number;
  pageSize?: number;
  orderNo?: string;
  contactName?: string;
  contactPhone?: string;
  productName?: string;
  assignedStaffId?: string;
  isPai?: number;
  serviceProviderId?: string;
}

export interface ServiceBookingOrderPoolListResponse {
  list: ServiceBookingOrderPoolItem[];
  total: number;
  page: number;
  pageSize: number;
}

export const serviceBookingOrderPoolService = {
  list: async (params?: ServiceBookingOrderPoolListParams): Promise<ServiceBookingOrderPoolListResponse> => {
    const response = await apiClient.get<ServiceBookingOrderPoolListResponse>('/service-booking-orders/pool', { params });
    return response.data;
  },
  assign: async (orderId: string, data: AssignServiceBookingOrderRequest): Promise<ServiceBookingOrder> => {
    const response = await apiClient.put<ServiceBookingOrder>(`/service-booking-orders/${orderId}/assign`, data);
    return response.data;
  },
};
